<div class="part-group" *ngFor="let partGroup of partGroups">
  <div class="cabinet-block head-block">
    <div class="cabinet-row">
      <div class="cabinet-name cabinet-cell">{{partGroup.name}}</div>
      <div class="cabinet-name area" *ngIf="partGroup.area > 0">{{partGroup.area | number: '1.2-2'}} SQFT</div>
    </div>
    <div class="group-note">
      <input class="arrow-input" type="text" pInputText BlockLateralArrowNavigation placeholder="Note"
             [ngModelOptions]="{standalone: true}" [(ngModel)]="partGroup.notes" (keyup)="groupNoteInput(partGroup)"
             [tabindex]="-1">
    </div>
  </div>

  <div class="cabinet-block created-manually from-parts"
       *ngFor="let cabinet of partGroup.parts; trackBy: trackEntityById; let isEven = even; let isOdd = odd, let i = index"
       [ngClass]="{'status-ready': cabinet[booleanString]}">

    <div class="cabinet-row">
      <div class="cab-done-icon" (click)="toggleCabinetStatus(cabinet)">
        <mat-icon matRipple>done</mat-icon>
      </div>
      <div class="cabinet-info manual-created">
        <div class="cabinet-name cabinet-cell">
          <span>#{{cabinet.cabinetNumber}} {{cabinet.cabinetName}}</span>
        </div>

        <div class="cabinet-description">
          <span *ngIf="cabinet.cnt > 1" style="margin-right: 0.2em;">({{cabinet.cnt}}) QTY</span>
          {{cabinet.description}} - {{cabinet.widthFraction}} x
          {{cabinet.lengthFraction}}
          <div class="space-block"></div>
          <div class="add-block" (click)="addNote(cabinet, i)" *ngIf="cabinet.colorNote === undefined">
            <i class="pi pi-plus-circle"></i>
          </div>
        </div>

        <div class="cabinet-description part-color-note" *ngIf="cabinet.colorNote !== undefined">
          <i class="pi pi-times cross-icon" (click)="clearNoteInput(cabinet)"></i>

          <input class="arrow-input" type="text" pInputText BlockLateralArrowNavigation placeholder="Note"
                 [ngModelOptions]="{standalone: true}" [(ngModel)]="cabinet.colorNote" (keyup)="colorNoteInput(cabinet)"
                 [tabindex]="-1">
        </div>
      </div>

      <div class="cabinet-icon cabinet-cell manual-icon" *ngIf="cabinet.createdManually">
              <span class="material-icons delete-icon" (click)="deleteCabinet(i)">
								clear
							</span>
      </div>
    </div>
  </div>
</div>
